import { Box, Button, Paper, Tooltip, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { useTranslation } from 'react-i18next'
import SygnetCluster from './SygnetCluster'
import { useSubscription } from '@/hooks/useSubscription'
import { useNavigate } from 'react-router-dom'

/** Navy gradient call-to-action card that launches the create-study wizard. */
export default function NewStudyCard({ onStart }: { onStart: () => void }) {
  const theme = useTheme()
  const { t } = useTranslation('dashboard')
  const navigate = useNavigate()
  const { isExpired } = useSubscription()

  return (
    <Paper
      sx={{
        position: 'relative',
        overflow: 'hidden',
        background: theme.affexy.gradients.ctaCard,
        color: theme.affexy.colors.white,
        borderRadius: `${theme.affexy.radii.md}px`,
        p: 2.25,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        minHeight: 132,
        gap: 2,
      }}
    >
      <Box
        aria-hidden
        sx={{ position: 'absolute', right: -28, top: -36, width: 160, height: 160, opacity: 0.5 }}
      >
        <SygnetCluster />
      </Box>

      <Box sx={{ position: 'relative', display: 'flex', flexDirection: 'column', gap: 0.75 }}>
        <Typography
          variant="overline"
          sx={{ fontSize: 11, letterSpacing: '0.08em', color: 'rgba(255,255,255,.6)' }}
        >
          {t('newStudyCard.eyebrow')}
        </Typography>
        <Typography
          sx={{ fontFamily: theme.affexy.fonts.heading, fontWeight: 700, fontSize: 20, lineHeight: 1.15, maxWidth: 220 }}
        >
          {t('newStudyCard.title')}
        </Typography>
      </Box>

      <Box sx={{ position: 'relative' }}>
        <Tooltip title={isExpired ? t('trial.blockedTooltip') : ''}>
          <span>
            <Button
              variant="contained"
              size="small"
              onClick={isExpired ? () => navigate('/plans') : onStart}
              endIcon={<ArrowForwardIcon sx={{ fontSize: 16 }} />}
            >
              {t('newStudyCard.cta')}
            </Button>
          </span>
        </Tooltip>
      </Box>
    </Paper>
  )
}
